import * as XLSX from "xlsx";

export const exportExcel = (data, columns, fileName = "table.xlsx") => {
  console.log(data, columns)
  // Формируем шапки колонок для Excel
  const headers = columns.map(col => {
    if (typeof col.title === "string") return col.title;

    // Если title — React-элемент, пытаемся достать props.title
    if (col.title?.props) {
      return col.title.props.title ?? (typeof col.title.props.children === "string" ? col.title.props.children : "Column");
    }

    return "Column";
  });

  const dataForExcel = data.map(item => {
    const row = {};
    columns.forEach((col, index) => {
      const key = col.dataIndex || col.key;
      if (!key) return;

      let value = item[key];

      // Используем renderPrint если есть
      if (col.printable?.renderPrint) {
        value = col.printable.renderPrint(value);
      }

      // Если value — объект, вытаскиваем label/title/name
      if (value && typeof value === "object") {
        value = value.label ?? value.title ?? value.name ?? JSON.stringify(value);
      }

      row[headers[index]] = value ?? "";
    });
    return row;
  });

  // Добавляем суммарную строку для числовых колонок
  const numericFields = columns
    .filter(col => col.type === "number" || col.dataIndex === "depos" || col.dataIndex === "dolg")
    .map(col => col.dataIndex);

  if (numericFields.length) {
    const totalRow = {};
    columns.forEach((col, index) => {
      if (numericFields.includes(col.dataIndex)) {
        totalRow[headers[index]] = data.reduce((sum, r) => sum + (Number(r[col.dataIndex]) || 0), 0);
      } else {
        totalRow[headers[index]] = col.dataIndex === "id" ? "Итого" : "";
      }
    });
    dataForExcel.push(totalRow);
  }

  const ws = XLSX.utils.json_to_sheet(dataForExcel);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Лист1");
  const outFileName = fileName.replace(/\.xlsx$/i, ".xls");
  XLSX.writeFile(wb, outFileName, { bookType: "biff8" });
};
